import React from 'react';
import { Box, Typography, Link, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import FeedbackIcon from '@mui/icons-material/Feedback';

const FooterContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(2, 2),
  backgroundColor: 'transparent',
  width: '100%',
  position: 'relative',
  bottom: 0,
  left: 0,
  right: 0,
}));

const FooterContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(3),
  flexWrap: 'wrap',
  justifyContent: 'center',
  maxWidth: 1400,
  width: '100%',
  border: '1.5px solid #D0DBEB',
  borderRadius: 20,
  background: '#fff',
  padding: '24px 32px',
  boxShadow: 'none',
  margin: '0 auto',
  position: 'relative',
}));

const FooterLink = styled(Link)(({ theme }) => ({
  color: '#1976d2',
  textDecoration: 'underline',
  fontSize: '14px',
  fontWeight: 400,
  '&:hover': {
    textDecoration: 'none',
    color: '#1565c0',
  },
}));

const FooterText = styled(Typography)(({ theme }) => ({
  color: '#23272E',
  fontSize: '14px',
  fontWeight: 400,
}));

const Separator = styled(Typography)(({ theme }) => ({
  color: '#A0A4AF',
  fontSize: '14px',
  fontWeight: 400,
}));

const FeedbackButton = styled(IconButton)(({ theme }) => ({
  color: '#A0A4AF',
  padding: theme.spacing(0.5),
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    color: '#23272E',
  },
}));

const Footer = () => {
  const handleFeedbackClick = (e) => {
    e.preventDefault();
    // Handle feedback click - could open a modal or redirect to feedback form
    console.log('Feedback clicked');
  };

  const handleLinkClick = (e) => {
    e.preventDefault();
    console.log('Link clicked:', e.target.textContent);
  };

  return (
    <FooterContainer>
      <FooterContent>
        <FooterText>© 2025 Perceptiviti</FooterText>
        <Separator>|</Separator>
        <FooterLink href="#" underline="hover" onClick={handleLinkClick}>
          All Rights Reserved
        </FooterLink>
        <Separator>|</Separator>
        <FooterLink href="#" underline="hover" onClick={handleLinkClick}>
          Terms of Service
        </FooterLink>
        <Separator>|</Separator>
        <FooterLink href="#" underline="hover" onClick={handleLinkClick}>
          Privacy Policy
        </FooterLink>
        <Separator>|</Separator>
        <Box display="flex" alignItems="center" gap={0.5}>
          <FeedbackButton onClick={handleFeedbackClick} size="small">
            <FeedbackIcon fontSize="small" />
          </FeedbackButton>
          <FooterText>Send feedback</FooterText>
        </Box>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer; 